export const MADRID = 'Europe/Madrid';
export const DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'] as const;

export const ymd = (t: number): string => new Date(t).toISOString().slice(0, 10);
export const dUTC = (d: string): number => { const [a, b, c] = d.split('-').map(Number); return Date.UTC(a, b - 1, c); };
export const addDays = (d: string, n: number): string => ymd(dUTC(d) + n * 864e5);
export const dow = (d: string): number => new Date(dUTC(d)).getUTCDay();
export const diffDays = (a: string, b: string): number => Math.round((dUTC(b) - dUTC(a)) / 864e5);

const dtf: Record<string, Intl.DateTimeFormat> = {};
function parts(ts: number, tz: string): Record<string, string> {
  const f = dtf[tz] || (dtf[tz] = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }));
  const o: Record<string, string> = {}; f.formatToParts(new Date(ts)).forEach(p => { o[p.type] = p.value; }); return o;
}
function tzOff(ts: number, tz: string): number { const p = parts(ts, tz); return Date.UTC(+p.year, +p.month - 1, +p.day, (+p.hour) % 24, +p.minute, +p.second) - Math.floor(ts / 1000) * 1000; }

/** Epoch ms of wall-clock time h:m on `date` in `tz`. */
export function zoned(date: string, h: number, m: number, tz: string): number {
  const [y, mo, d] = date.split('-').map(Number); const g = Date.UTC(y, mo - 1, d, h, m);
  let t = g - tzOff(g, tz); t = g - tzOff(t, tz); return t;
}
export function localDate(ts: number, tz: string = MADRID): string { const p = parts(ts, tz); return p.year + '-' + p.month + '-' + p.day; }
export function hhmm(ts: number, tz: string = MADRID): string { const p = parts(ts, tz); return String(+p.hour % 24).padStart(2, '0') + ':' + p.minute; }
export function dm(d: string): string { const [, m, dd] = d.split('-'); return (+dd) + '/' + (+m); }
